import React, { useEffect, useState } from "react";
import "./ArticleSection.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import {
  deleteArticles,
  getArticles,
} from "../../../../requests/newArticleAPI";
import { toast } from "react-toastify";
const ArticleSection = () => {
  // const [rows, setRows] = useState([
  //   {
  //     title: "Terms & Conditions",
  //     category: "Legal",
  //     lastUpdated: "Jul 2, 2025",
  //     status: "Active",
  //     version: "v3.2",
  //     editor: "Eugene Gerry",
  //     action: <img src="/images/icons/pen.svg" alt="icon" />,
  //     img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
  //     selected: false,
  //   },
  //   {
  //     title: "Privacy Policy",
  //     category: "Legal",
  //     lastUpdated: "Jun 18, 2025",
  //     status: "Active",
  //     version: "v2.7",
  //     editor: "Eugene Gerry",
  //     action: <img src="/images/icons/pen.svg" alt="icon" />,
  //     img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
  //     selected: false,
  //   },
  //   {
  //     title: "How to Reset Password",
  //     category: "Help Center",
  //     lastUpdated: "Jun 28, 2025",
  //     status: "Active",
  //     version: "v1.1",
  //     editor: "Eugene Gerry",
  //     action: <img src="/images/icons/pen.svg" alt="icon" />,
  //     img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
  //     selected: false,
  //   },
  //   {
  //     title: "Troubleshooting eSIM",
  //     category: "Technical Docs",
  //     lastUpdated: "Jul 1, 2025",
  //     status: "Draft",
  //     version: "v1.9",
  //     editor: "Eugene Gerry",
  //     action: <img src="/images/icons/pen.svg" alt="icon" />,
  //     img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
  //     selected: false,
  //   },
  //   {
  //     title: "Refund & Return Policy",
  //     category: "Legal",
  //     lastUpdated: "May 15, 2025",
  //     status: "Active",
  //     version: "v1.0",
  //     editor: "Eugene Gerry",
  //     action: <img src="/images/icons/pen.svg" alt="icon" />,
  //     img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
  //     selected: false,
  //   },
  // ]);
  const [rows, setRows] = useState([]);
  const [id, setId] = useState("");
  // Is header checkbox checked?
  const allChecked = rows.every((row) => row.selected);

  // Toggle all rows
  const handleSelectAll = () => {
    const newValue = !allChecked;
    setRows(rows.map((row) => ({ ...row, selected: newValue })));
  };

  // Toggle single row
  const handleRowSelect = (index) => {
    const updated = [...rows];
    updated[index].selected = !updated[index].selected;
    setRows(updated);
  };

  const userFormik = useFormik({
    initialValues: {
      serviceType: "",
      vendor: "",
      markupPercentage: "",
      confirmPercentage: "",
    },
    validationSchema: Yup.object({
      serviceType: Yup.string().required("Please select a service type"),
      vendor: Yup.string(), // Optional
      markupPercentage: Yup.number()
        .typeError("Must be a number")
        .min(0, "Must be at least 0")
        .max(100, "Cannot exceed 100")
        .required("percentage is required"),
      confirmPercentage: Yup.number()
        .typeError("Must be a number")
        .oneOf([Yup.ref("markupPercentage")], "Must match markup percentage")
        .required("percentage is required"),
    }),
    onSubmit: (values) => {
      console.log("Form values:", values);
      alert(JSON.stringify(values, null, 2));
    },
  });
  const getArticle = async () => {
    try {
      const response = await getArticles();

      const data = response?.data?.articles?.map((item) => ({
        title: item.title || "",
        category: item.category || "",
        lastUpdated: new Date(item.updatedAt).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        }),
        status: item.status === "Published" ? "Active" : item.status,
        version: `v${item.version || "1.0"}`,
        editor: item.userId?.email || "Unknown",
        action: <img src="/images/icons/pen.svg" alt="icon" />,
        img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
        media: item.media || [],
        selected: false,
        id: item._id,
      }));
      setRows(data);
    } catch (error) {}
  };
  const deleteArticle = async () => {
    try {
      const response = await deleteArticles(id);
      console.log(response);
      getArticle();
      toast.success("Article Deleted Successfully!");
    } catch (error) {
      toast.error("Something Went Wrong!");
    } finally {
      document.getElementById("closeDeleteModalBtn")?.click();
    }
  };
  useEffect(() => {
    getArticle();
  }, []);
  return (
    <section className="article-page-section">
      <div className="search-input">
        <h5 className="form-title">Article Management</h5>
        <Link to="/add-article" className="custom-btn">
          Add Article
        </Link>
      </div>
      <div className="table-responsive">
        <table className="table table-striped vendor-info">
          <thead className="table-dark">
            <tr>
              <th>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </th>
              <th>Title</th>
              <th>Category</th>
              <th>Last Updated</th>
              <th>Status</th>
              <th>Version</th>
              <th>Editor(s)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                <td>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={() => handleRowSelect(i)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td>
                <td>{row?.title}</td>
                <td>{row?.category}</td>
                <td>{row?.lastUpdated}</td>
                <td>{row?.status}</td>
                <td>{row?.version}</td>
                <td>{row?.editor}</td>
                <td>
                  <span className="action-link">
                    <Link to={`/edit-article/${row.id}`}>{row.action}</Link>
                    <div
                      data-bs-toggle="modal"
                      onClick={() => {
                        setId(row?.id);
                      }}
                      data-bs-target="#cancelModal"
                    >
                      {row?.img}
                    </div>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        className="modal fade"
        id="articleManagementModal"
        tabIndex="-1"
        aria-labelledby="articleManagementModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content articleManagement-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Add Markup</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>
              <form className="user-info" onSubmit={userFormik.handleSubmit}>
                <div className="user-inputs">
                  <div className="row">
                    <strong className="mb-2">Select Service & Vendor</strong>
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <input
                          type="text"
                          name="serviceType"
                          placeholder="eSim"
                          value={userFormik.values.serviceType}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <label className="floating-label-text">
                          Service Type
                        </label>
                        {userFormik.touched.serviceType &&
                          userFormik.errors.serviceType && (
                            <div className="error">
                              {userFormik.errors.serviceType}
                            </div>
                          )}
                      </div>
                    </div>

                    {/* ✅ Vendor (optional) */}
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="vendor"
                          value={userFormik.values.vendor}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        >
                          <option value="">Choose Service Type</option>
                          <option value="eSim">eSim</option>
                          <option value="Flights">Flights</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Tours">Tours</option>
                        </select>
                        <label className="floating-label-text">
                          Vendor (Optional)
                        </label>
                        {userFormik.touched.vendor &&
                          userFormik.errors.vendor && (
                            <div className="error">
                              {userFormik.errors.vendor}
                            </div>
                          )}
                      </div>
                    </div>

                    <strong className="mb-2 mt-3">Markup Percentage</strong>

                    {/* ✅ Markup Percentage */}
                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="markupPercentage"
                          placeholder="000"
                          value={userFormik.values.markupPercentage}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <span>GB</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {userFormik.touched.markupPercentage &&
                          userFormik.errors.markupPercentage && (
                            <div className="error">
                              {userFormik.errors.markupPercentage}
                            </div>
                          )}
                      </div>
                    </div>

                    {/* ✅ Confirm Percentage */}
                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="confirmPercentage"
                          placeholder="000"
                          value={userFormik.values.confirmPercentage}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <span>%</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {userFormik.touched.confirmPercentage &&
                          userFormik.errors.confirmPercentage && (
                            <div className="error">
                              {userFormik.errors.confirmPercentage}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn">
                    Add Markup
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="cancelModal"
        tabIndex="-1"
        aria-labelledby="cancelModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content markup-modal">
            <div className="modal-body">
              <h5 className="modal-title">Delete Article</h5>
              <p>Are you sure you want to remove this entry. </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn"
                onClick={() => {
                  deleteArticle();
                }}
              >
                Delete
              </button>
            </div>
          </div>
          <button
            type="button"
            id="closeDeleteModalBtn"
            data-bs-dismiss="modal"
            style={{ display: "none" }}
          ></button>
        </div>
      </div>
    </section>
  );
};

export default ArticleSection;
